import React, { useState } from 'react';
import './BookCover.css';

/**
 * Shared book cover component with graceful fallback for broken images.
 * Shows a styled placeholder with emoji + truncated title when no image or image fails to load.
 */
export default function BookCover({ src, alt, className = '', emoji = '📖' }) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div className={`bookcover-placeholder ${className}`}>
        <span className="bookcover-placeholder-emoji">{emoji}</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={`bookcover-img ${className}`}
      onError={() => setFailed(true)}
      loading="lazy"
    />
  );
}
